
const x = {
  "Disclaimer_LimitedData": {
    "id": "Disclaimer.LimitedData",
    "locale": {
      "de-DE": "Zurzeit wird nur ein beschränkter Datensatz angezeigt.",
      "en-US": "Currently showing a limited data set.",
      "es-ES": "Mostrando actualmente un conjunto limitado de datos.",
      "fr-FR": "Affichage d'un ensemble de données limité pour l'instant.",
      "it-IT": "Attualmente viene visualizzata una serie di dati limitata.",
      "ja-JP": "現在、限定的なデータ セットを表示しています。",
      "ko-KR": "현재 제한된 데이터 집합을 표시하고 있습니다.",
      "nl-NL": "Momenteel wordt een beperkte gegevensverzameling getoond.",
      "pl-PL": "Aktualnie przedstawiany jest ograniczony zestaw danych.",
      "pt-BR": "Mostrando um conjunto de dados limitado.",
      "ru-RU": "В настоящее время отображается ограниченный набор данных.",
      "sv-SE": "Just nu visas en begränsad uppsättning data.",
      "tr-TR": "Şu anda sınırlı bir veri kümesi gösteriliyor.",
      "zh-CN": "当前正显示有限的数据集。",
      "zh-TW": "目前顯示的是有限的資料集。"
    }
  },
  "Disclaimer_NegativeOrZeroValues": {
    "id": "Disclaimer.NegativeOrZeroValues",
    "locale": {
      "de-DE": "Die in den Datensätzen enthaltenen negativen oder 0-Werte können nicht in diesem Diagramm dargestellt werden.",
      "en-US": "The data set contains negative or zero values that cannot be shown in this chart.",
      "es-ES": "El conjunto de datos contiene valores negativos o cero que no se pueden mostrar en este gráfico.",
      "fr-FR": "L'ensemble de données contient des valeurs négatives ou égales à zéro impossibles à afficher dans ce graphique.",
      "it-IT": "La serie di dati contiene valori negativi o uguali a zero che non possono essere visualizzati in questo grafico.",
      "ja-JP": "データ セットには、本チャートに表示できない負の値またはゼロ値が含まれています。",
      "ko-KR": "데이터 집합에 해당 차트에 표시할 수 없는 음수 값 또는 zero 값이 포함되어 있습니다.",
      "nl-NL": "De gegevensverzameling bevat negatieve waarden of nulwaarden die niet kunnen worden weergegeven in deze grafiek.",
      "pl-PL": "Zestaw danych zawiera wartości ujemne lub zerowe, których nie można przedstawić w tym wykresie.",
      "pt-BR": "O conjunto de dados contém valores negativos ou iguais a zero que não podem ser mostrados neste gráfico.",
      "ru-RU": "Набор данных содержит отрицательные или нулевые значения, которые невозможно показать в этой диаграмме.",
      "sv-SE": "Datauppsättningen innehåller negativa värden eller nollvärden som inte kan visas i detta diagram.",
      "tr-TR": "Veri kümesi, bu grafikte gösterilemeyen negatif veya sıfır değerlerini içeriyor.",
      "zh-CN": "数据集中包含无法在此图表中显示的负值或零值。",
      "zh-TW": "資料集包含無法在此圖表中顯示的負值或零值。"
    }
  },
  "Disclaimer_NoDataExist": {
    "id": "Disclaimer.NoDataExist",
    "locale": {
      "de-DE": "Die Auswahlen haben für dieses Diagramm keine Daten generiert.",
      "en-US": "The selections generated no data for this chart.",
      "es-ES": "Las selecciones no han generado datos para este gráfico.",
      "fr-FR": "Les sélections n'ont pas généré de données pour ce graphique.",
      "it-IT": "Le selezioni non hanno generato dati per questo grafico.",
      "ja-JP": "このチャートには選択からデータが生成されませんでした。",
      "ko-KR": "선택 내용으로 해당 차트에 대한 데이터가 생성되지 않았습니다.",
      "nl-NL": "De selecties hebben geen gegevens voor de grafiek gegenereerd.",
      "pl-PL": "Selekcje nie spowodowały wygenerowania danych dla tego wykresu.",
      "pt-BR": "As seleções não geraram dados para este gráfico.",
      "ru-RU": "В результате выборок данные для этой диаграммы не созданы.",
      "sv-SE": "Urvalen genererade inga data för detta diagram.",
      "tr-TR": "Seçimler bu grafik için hiç veri oluşturmadı.",
      "zh-CN": "选择未生成此图表的数据。",
      "zh-TW": "此選項無法產生任何適用於此圖表的資料。"
    }
  },
  "Disclaimer_OnlyNaNData": {
    "id": "Disclaimer.OnlyNaNData",
    "locale": {
      "de-DE": "Das Diagramm wird nicht angezeigt, da es nur nicht definierte Werte enthält.",
      "en-US": "The chart is not displayed because it contains only undefined values.",
      "es-ES": "El gráfico no se muestra porque solo contiene valores indefinidos.",
      "fr-FR": "Le graphique n'est pas affiché, car il contient uniquement des valeurs non définies.",
      "it-IT": "Il grafico non è visualizzato poiché contiene solo valori non definiti.",
      "ja-JP": "未定義の値しか含まれていないため、チャートは表示されていません。",
      "ko-KR": "정의되지 않은 값만 포함되어 있으므로 차트가 표시되지 않습니다.",
      "nl-NL": "De grafiek wordt niet weergegeven omdat deze alleen ongedefinieerde waarden bevat.",
      "pl-PL": "Wykres nie jest wyświetlany, ponieważ zawiera wartości niezdefiniowane.",
      "pt-BR": "O gráfico não foi exibido, porque contém apenas valores não definidos.",
      "ru-RU": "Диаграмма не отображается, поскольку она содержит только неопределенные значения.",
      "sv-SE": "Diagrammet visas inte eftersom det enbart innehåller odefinierade värden.",
      "tr-TR": "Yalnızca tanımsız değerleri içermesi nedeniyle grafik görüntülenmiyor.",
      "zh-CN": "未显示图表，因为它仅包含未定义的值。",
      "zh-TW": "系統不會顯示圖表，因為該圖表僅包含未定義的值。"
    }
  },
  "Disclaimer_OnlyNegativeOrZeroValues": {
    "id": "Disclaimer.OnlyNegativeOrZeroValues",
    "locale": {
      "de-DE": "Das Diagramm wird nicht angezeigt, da es nur negative oder 0-Werte enthält.",
      "en-US": "The chart is not displayed because it contains only negative or zero values.",
      "es-ES": "El gráfico no se muestra porque sólo contiene valores negativos o valores cero.",
      "fr-FR": "Le graphique n'est pas affiché, car il contient uniquement des valeurs négatives ou égales à zéro.",
      "it-IT": "Il grafico non viene visualizzato poiché contiene solo valori negativi o uguali a zero.",
      "ja-JP": "チャートは負の値またはゼロ値しか含まれていないため、表示されていません。",
      "ko-KR": "음수 또는 zero 값만 포함되어 있으므로 차트가 표시되지 않습니다.",
      "nl-NL": "De grafiek wordt niet weergegeven omdat het alleen negatieve waarden of nulwaarden bevat.",
      "pl-PL": "Wykres nie jest wyświetlany, ponieważ zawiera wartości ujemne lub zerowe.",
      "pt-BR": "O gráfico não foi exibido, porque contém apenas valores negativos ou zero.",
      "ru-RU": "Диаграмма не отображается, поскольку она содержит только отрицательные или нулевые значения.",
      "sv-SE": "Diagrammet visas inte eftersom det enbart innehåller negativa eller nollvärden",
      "tr-TR": "Yalnızca negatif veya sıfır değerlerini içermesi nedeniyle grafik görüntülenmiyor.",
      "zh-CN": "未显示图表，因为它仅包含负值或零值。",
      "zh-TW": "系統不會顯示圖表，因為該圖表僅包含負值或零值。"
    }
  },
  "Cells": {
    "id": "Cells",
    "locale": {
      "de-DE": "Zellen",
      "en-US": "Cells",
      "es-ES": "Celdas",
      "fr-FR": "Cellules",
      "it-IT": "Celle",
      "ja-JP": "セル",
      "ko-KR": "셀",
      "nl-NL": "Cellen",
      "pl-PL": "Komórki",
      "pt-BR": "Células",
      "ru-RU": "Ячейки",
      "sv-SE": "Celler",
      "tr-TR": "Hücreler",
      "zh-CN": "单元格",
      "zh-TW": "儲存格"
    }
  },
  "Column": {
    "id": "Column",
    "locale": {
      "de-DE": "Spalte",
      "en-US": "Column",
      "es-ES": "Columna",
      "fr-FR": "Colonne",
      "it-IT": "Colonna",
      "ja-JP": "列",
      "ko-KR": "열",
      "nl-NL": "Kolom",
      "pl-PL": "Kolumna",
      "pt-BR": "Coluna",
      "ru-RU": "Столбец",
      "sv-SE": "Kolumn",
      "tr-TR": "Sütun",
      "zh-CN": "列",
      "zh-TW": "資料行"
    }
  },
  "Size": {
    "id": "Size",
    "locale": {
      "de-DE": "Größe",
      "en-US": "Size",
      "es-ES": "Tamaño",
      "fr-FR": "Taille",
      "it-IT": "Dimensione",
      "ja-JP": "サイズ",
      "ko-KR": "크기",
      "nl-NL": "Grootte",
      "pl-PL": "Rozmiar",
      "pt-BR": "Tamanho",
      "ru-RU": "Размер",
      "sv-SE": "Storlek",
      "tr-TR": "Boyut",
      "zh-CN": "大小",
      "zh-TW": "大小"
    }
  },
  "Share": {
    "id": "Share",
    "locale": {
      "de-DE": "Anteil",
      "en-US": "Share",
      "es-ES": "Cuota",
      "fr-FR": "Part",
      "it-IT": "Percentuale",
      "ja-JP": "割合",
      "ko-KR": "공유",
      "nl-NL": "Aandeel",
      "pl-PL": "Udział",
      "pt-BR": "Percentual",
      "ru-RU": "Доля",
      "sv-SE": "Andel",
      "tr-TR": "Pay",
      "zh-CN": "份额",
      "zh-TW": "佔有率"
    }
  }
};

export {
  x as default
};
